import { render, staticRenderFns } from "./nav-app-item.vue?vue&type=template&id=38f850bc&scoped=true"
import script from "./nav-app-item.vue?vue&type=script&lang=js"
export * from "./nav-app-item.vue?vue&type=script&lang=js"
import style0 from "./nav-app-item.vue?vue&type=style&index=0&id=38f850bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f850bc",
  null
  
)

export default component.exports